import React, { useState } from "react";
import logo from "../images/logo.png";
import { NavLink } from "react-router-dom";
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
const products = [
  { id: 1, name: "Pastries Paradise", },
  { id: 2, name: "Choco Blis Bites", },
  { id: 3, name: "Golden Layers", },
  { id: 4, name: "The Pizza Pallete",  },
  { id: 5, name: "The Burger Carft", },
  { id: 6, name: "The Sandwich Club",  },
  { id: 7, name: "Crispy Corner",  },
  { id: 11, name: "Mocktail Magic", },
  { id: 12, name: "Shake Heaven",  },
  { id: 13, name: "The Feast Combo", },
  { id: 14, name: "Frosted Delights",  },
  { id: 15, name: "Beverages",  },
  { id: 16, name: "Frost & Fizz Mellow Magic Combo",},
];
  return (
    <header className="header">
      <NavLink to="/">
        <img className="logo" src={logo}></img>
      </NavLink>

      <nav className={`nav-links ${isOpen ? "open" : ""}`}>
        <NavLink to="/about" className="text-decoration-none">
          <a href="#about" onClick={closeMenu}>About</a>
        </NavLink>
        <a href="#products" onClick={closeMenu}>Our Products</a>
        <NavLink to="/contactus" className="text-decoration-none">
          <a href="#contact" onClick={closeMenu}>Contact Us</a>
        </NavLink>

      </nav>

      <div className="menu-icon" onClick={toggleMenu}>
        <div className={`bar ${isOpen ? "rotate1" : ""}`}></div>
        <div className={`bar ${isOpen ? "fade" : ""}`}></div>
        <div className={`bar ${isOpen ? "rotate2" : ""}`}></div>
      </div>
    </header>
  );
};

export default Header;
